import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toJS } from '../../../containers/to-js';
import { getWorkflowFromCode } from '../../../actions/workflows';
import { Button } from 'reactstrap';

class ActionElementGateway extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPopupOpen: false
        };

        this.popupRef = null;
        this.timer = null;

        this.onGatewayHandler = this.onGatewayHandler.bind(this);
        this.receiveMessage = this.receiveMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage);

        if (this.popupRef && !this.popupRef.closed) {
            this.popupRef.close();
        }

        if (this.timer) {
            clearInterval(this.timer);
        }
    }


    receiveMessage(event) {
        if (event.origin !== window.location.origin) return;

        const { code, state } = event.data || {};

        if (code) {
            console.log("Authorization Code Received:", code);

            this.props.getWorkflowFromCode(code);

            if (this.popupRef) {
                this.popupRef.close();
            }

            this.setState({ isPopupOpen: false });
        }
    }

    onGatewayHandler() {

        const { layoutItem } = this.props;

        const redirectUrl =
            layoutItem &&
            layoutItem.itemProperties &&
            layoutItem.itemProperties.actionButtonConfig &&
            layoutItem.itemProperties.actionButtonConfig.redirectUrl;

        const clientId =
            layoutItem &&
            layoutItem.itemProperties &&
            layoutItem.itemProperties.actionButtonConfig &&
            layoutItem.itemProperties.actionButtonConfig.clientId;

        const uaePassState =
            layoutItem &&
            layoutItem.itemProperties &&
            layoutItem.itemProperties.actionButtonConfig &&
            layoutItem.itemProperties.actionButtonConfig.uaePassState;

        if (redirectUrl && clientId && uaePassState) {
            const scope = encodeURIComponent(
                "urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId"
            );

            const acrValues = encodeURIComponent(
                "urn:safelayer:tws:policies:authentication:level:low"
            );

           

            const url =
                `https://stg-id.uaepass.ae/idshub/authorize?` +
                `redirect_uri=${encodeURIComponent(redirectUrl)}` +
                `&client_id=${clientId}` +
                `&response_type=code` +
                `&state=${uaePassState}` +
                `&scope=${scope}` +
                `&acr_values=${acrValues}`;

                console.log(`url for UAE Pass`, url)

       

            this.popupRef = window.open(
                url,
                "uaePassLogin",
                "width=600,height=700"
            );

            if (!this.popupRef) {
                console.log("Popup blocked");
                return;
            }

            this.setState({ isPopupOpen: true });

            this.timer = setInterval(() => {
                if (!this.popupRef || this.popupRef.closed) {
                    clearInterval(this.timer);
                    this.setState({ isPopupOpen: false });
                    console.log("Popup Closed");
                }
            }, 500);
        }
    }

    render() {
        return (
            <div>
                <Button
                    onClick={this.onGatewayHandler}
                    disabled={this.state.isPopupOpen}
                >
                    {this.state.isPopupOpen
                        ? "Processing..."
                        : (this.props.label && this.props.label.text
                            ? this.props.label.text
                            : "Action")}
                </Button>
            </div>
        );
    }
}

ActionElementGateway.contextTypes = {
    router: PropTypes.object
};

const mapStateToProps = (state) => ({
    user: state.get('user')
});

const mapDispatchToProps = (dispatch) => ({
    getWorkflowFromCode: (code) =>
        dispatch(getWorkflowFromCode(code))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(toJS(ActionElementGateway));
